import React from 'react'
import System from 'src/helper/system';
import { useOrderStore } from 'src/hooks/order';
import { __remove, __set } from 'src/store/axios_indicator';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';

const OrderJapanInvoicePopup = (props) => {
    const [{ }, { }, { order_email_invoice }] = useOrderStore();
    const [__check] = useAxiosIndicatorCheck();

    const { SetStatus, data } = props;
    const { translation: t } = System;

    const onSubmit = async () => {
        await order_email_invoice({ invoiceNumber: data.invoiceNumber, webOrderNumber: data?.orderNumber });
        SetStatus(false)
    }

    return (
        <>
            <div className="avnet-modal modal-500">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="modal-title m-auto">{t('invoiceIssuanceRequest')}</h3>
                    </div>

                    {/* Modal body */}
                    <div className="modal-body py-0">
                        <div className='ms-4 me-4'>
                            <div className='bs5 row'>
                                <div className='col-md-12'>
                                    <p className='font-13 font-arial text-center'>
                                        {t('japanInvoicePopupLine1')}. <br />#{data.orderNumber}<br/> {t('japanInvoicePopupLine2')} <a href="mailto:OnlineSupport-Japan@avnet.com" className="text-blue">OnlineSupport-Japan@avnet.com</a> {t('japanInvoicePopupLine3')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center mt-5 d-flex">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-primary btn-sm w145 text-uppercase" data-dismiss="modal" onClick={() => {
                                onSubmit()
                            }}>
                                {__check('ORDER_EMAIL_INVOICE').status ? <i className="fa fa-spinner fa-spin" /> : "Yes"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrderJapanInvoicePopup